import { processError } from '../utils/processError';
import api from './index';

interface GetOverviewParams {
  search?: string;
  isDashboard?: boolean;
  institutionId: number;
  overviewSort?: 'Newest_Oldest' | 'Oldest_Newest';
  dashboardSortOrder?: 'Month' | 'Week';
  pageNumber?: number;
  pageSize?: number;
}

const getOverview = async (props: GetOverviewParams ) => {
  try {
    const { data } = await api.get(
      `/testservice/api/Report/GetOverview`,
      { params: {...props} }
    );
    return data?.data;
  } catch (e) {
    processError(e);
  }
};

const getScoreDetail = async (candidateResultId: number|undefined) => {
if(candidateResultId !== undefined){
  try {
    const { data } = await api.get(
      `/testservice/api/Report/GetScoreDetail?candidateResultId=${candidateResultId}`
    );
    return data?.data;
  } catch (e) {
    processError(e);
  }
}
};

const getTestDetail = async (institutionId: number,testId?:number,subjectId?:number,periodId?:number,categoryId?:number,xport = false,search="") => {
const params = {testId,
  subjectId,
  periodId,
  categoryId,
  export:xport,
  search
}
  try {
    const { data } = await api.get(
      `/testservice/api/Report/GetTestDetail?institutionId=${institutionId}`,{params}
    );
    return data;
  } catch (e) {
    processError(e);
  }
};


const getTestTakerCount = async (institutionId: number) => {
  try {
    const { data } = await api.get(
      `/testservice/api/Report/Get-TestTakerCount/${institutionId}`
    );
    return data?.data;
  } catch (e) {
    processError(e);
  }
};


const getUpcomingTests = async (institutionId: number) => {
  try {
    const { data } = await api.get(
      `/testservice/api/Report/Get-UpcomingTests/${institutionId}`
    );
    return data?.data;
  } catch (e) {
    processError(e);
  }
};


const getTestIntegrity = async (institutionId: number) => {
  try {
    const { data } = await api.get(
      `/testservice/api/Report/Get-TestIntegrity/${institutionId}`
    );
    return data?.data;
  } catch (e) {
    processError(e);
  }
};

const getTotalTestSuccessRate = async (institutionId: number) => {
  try {
    const { data } = await api.get(
      `/testservice/api/Report/Get-TotalTestSuccessRate/${institutionId}`
    );
    return data?.data;
  } catch (e) {
    processError(e);
  }
};
const getFileStats = async (candidateId: number, testId: number) => {
  try {
    const { data } = await api.get(
      `/testService/api/Test/candidate/file-stats?candidateId=${candidateId}&testId=${testId}`
    );
    return data?.data;
  } catch (e) {
    processError(e);
  }
};



const reportApi = {
  getOverview,
  getTestDetail,
  getScoreDetail,
  getTestTakerCount,
  getUpcomingTests,
  getTestIntegrity,
  getTotalTestSuccessRate,
  getFileStats,
};

export default reportApi;
